var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"navigation-links"},[_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":"/dashboard"}},[_c('font-awesome-icon',{attrs:{"icon":"home"}}),_vm._v(" Volver\n      ")],1)],1),_c('survey-list',{attrs:{"surveys":_vm.surveys}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }